import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { GENERATED_SCHEMA_TITLE_FIELD_NAME } from '@cli-constants/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { isStringLikeSlugField } from './is-string-like-slug-field.js'

export function hasPersistedTitleField(fields: SchemaField[]): boolean {
  return flattenFields(fields).some(
    (field) => field.name === GENERATED_SCHEMA_TITLE_FIELD_NAME && isStringLikeSlugField(field)
  )
}
